// Copyright (c) 2021 WiseTime. All rights reserved.

import React, { forwardRef } from "react"
import styled from "styled-components/macro"
import "react-datepicker/dist/react-datepicker.css"
import SvgIcon from "features/shared/SvgIcon"
import { isIosWiseTime } from "../../../app/config"

const CalendarButton = styled.button`
  display: flex;
  position: relative;
  cursor: pointer;
  padding: ${isIosWiseTime ? "10px 8px 11px" : "11px 8px"};
  border-left: 1px solid ${({ theme }): string => theme.colors.silverSand};
  transition: background-color .3s ease;
  
  &:hover {
    background-color: ${({ theme }): string => theme.colors.white};
  }

  @media (min-width: ${({ theme }): string => theme.screen.sm}) {
    width: 50px;
  }

  @media (max-width: ${({ theme }): string => theme.screen.sm}) {
    width: 44px;
  }
`

const CalendarLink = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .3s;
`

const StyledSvgIcon = styled(SvgIcon)`
  pointer-events: none;
  width: 2.2rem;
  min-width: 2.2rem;
  height: 2.2rem;
`

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

// "forwardRef" is required to avoid error "Function components cannot be given refs"
// https://github.com/Hacker0x01/react-datepicker/issues/862#issuecomment-522333766
const CustomCalendarInput = forwardRef<HTMLDivElement, Props>((
  props,
  ref,
): React.ReactElement<Props> => (
  <CalendarButton onClick={props.onClick} className="react-datepicker-ignore-onclickoutside">
    <CalendarLink ref={ref}>
      <StyledSvgIcon name="calendar-tiles"/>
    </CalendarLink>
  </CalendarButton>
))

export default CustomCalendarInput
